import redDotWinner2025Award from './assets/red_dot_winner_2025.png';
import wallpaperDesignAward2015WinnerAward from './assets/wallpaper_design_award_2015_winner.png';
import wallpaperDesignAward2017Award from './assets/wallpaper_design_award_2017.png';
import wallpaperDesignAward2026Award from './assets/wallpaper_design_award_2026.png';

// Types
import { CMS_ENUM_RUG_AWARD } from '../../../../../types/global';

export const getAwardName = (award?: CMS_ENUM_RUG_AWARD | null) => {
  switch (award) {
    case CMS_ENUM_RUG_AWARD.RED_DOT_AWARD_2025:
      return 'Red Dot Winner 2025';

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2015_WINNER:
      return 'Wallpaper* Design Award 2015 – Winner';

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2017:
      return 'Wallpaper* Design Award 2017';

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2026:
      return 'Wallpaper* Design Awards 2026';

    default:
      return null;
  }
};

export const getAwardUrl = (award?: CMS_ENUM_RUG_AWARD | null) => {
  switch (award) {
    case CMS_ENUM_RUG_AWARD.RED_DOT_AWARD_2025:
      return redDotWinner2025Award;

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2015_WINNER:
      return wallpaperDesignAward2015WinnerAward;

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2017:
      return wallpaperDesignAward2017Award;

    case CMS_ENUM_RUG_AWARD.WALLPAPER_DESIGN_AWARD_2026:
      return wallpaperDesignAward2026Award;

    default:
      return null;
  }
};
